"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataTableContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _DataTable = require("./DataTable");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const BODY_ROW_HOVER_CLASS_NAME = 'cds-DataTable-BodyRow--Hover';
const DataTableContainer = _ref => {
  let {
    additionOptions,
    removalOptions,
    ...originalProps
  } = _ref;
  const {
    isHoverable,
    rows
  } = originalProps;
  const [currentRowIndexes, setRowCurrentIndexes] = (0, _react.useState)([...Array(rows.length).keys()]);
  const [addedRows, setAddedRows] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    setRowCurrentIndexes([...Array(rows.length).keys()]);
  }, [rows.length]);
  const handleDeleteButtonClick = deleteIndex => {
    setRowCurrentIndexes(currentRowIndexes.filter(index => index !== deleteIndex));
    removalOptions && removalOptions.callback && removalOptions.callback();
  };
  const createDeleteButton = deleteIndex => {
    if (removalOptions) {
      return /*#__PURE__*/_react.default.cloneElement(removalOptions.button, {
        onClick: e => {
          e.stopPropagation();
          handleDeleteButtonClick(deleteIndex);
        }
      });
    }
    return null;
  };
  const handleAddButtonClick = () => {
    if (additionOptions && additionOptions.addingRow) {
      setAddedRows([...addedRows, additionOptions.addingRow]);
      setRowCurrentIndexes([...currentRowIndexes, currentRowIndexes.length > 0 ? Math.max((currentRowIndexes[currentRowIndexes.length - 1] ?? 0) + 1, rows.length) : rows.length]);
      additionOptions.callback && additionOptions.callback();
    }
  };
  const createAddButton = () => {
    if (additionOptions) {
      return additionOptions.addingRow ? /*#__PURE__*/_react.default.cloneElement(additionOptions.button, {
        onClick: () => handleAddButtonClick()
      }) : additionOptions.button;
    }
    return null;
  };
  const setRowHover = (e, row, hoverAction) => {
    if (row.hasSubRow) {
      // @ts-ignore
      e.currentTarget.nextSibling.classList[hoverAction](BODY_ROW_HOVER_CLASS_NAME);
    }
    if (row.isSubRow) {
      // @ts-ignore
      e.currentTarget.previousSibling.classList[hoverAction](BODY_ROW_HOVER_CLASS_NAME);
    }
  };
  const handleRowMouseEnter = (callback, row) => e => {
    if (isHoverable) {
      setRowHover(e, row, 'add');
    }
    callback && callback();
  };
  const handleRowMouseLeave = row => e => {
    if (isHoverable) {
      setRowHover(e, row, 'remove');
    }
  };
  return /*#__PURE__*/_react.default.createElement(_DataTable.DataTable, (0, _extends2.default)({}, originalProps, {
    addedRows: addedRows,
    areRowsRemovable: !!removalOptions,
    createAddButton: createAddButton,
    createDeleteButton: createDeleteButton,
    currentRowIndexes: currentRowIndexes,
    isRowAddable: !!additionOptions,
    onRowMouseEnter: handleRowMouseEnter,
    onRowMouseLeave: handleRowMouseLeave
  }));
};
exports.DataTableContainer = DataTableContainer;
//# sourceMappingURL=DataTableContainer.js.map